<template>
  <!-- 终止试用 -->
  <div>
    <h1 class="item-title">{{ $t('components_contract_stop_test.he_tong_xin_xi') }}</h1>
    <div class="item-title-info">
      <el-row>
        <!-- <el-col :span="8">
          <span class="label">{{ $t('pcs_test_he_tong_lei_xing') }}:</span>
          <span class="value">{{ getDicValue('crm_contract_type', detail.contractType )}}</span>
        </el-col> -->
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_test.ding_dan_bian_hao') }}:</span>
          <span class="value">{{ detail.contractNo }}</span>
        </el-col>
        <!-- <el-col :span="8"
          ><span class="label">{{ $t('pcs_test_sghth') }}:</span>
          <span class="value">{{ detail.customContractNo }}</span>
        </el-col> -->
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_test.jfsqdbgs') }}:</span>
          <span class="value">{{ detail.partyAName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_test.yi_fang') }}:</span>
          <span class="value">{{ detail.customerName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_test.shou_hou_gong_si') }}:</span>
          <span class="value">{{ detail.afterServiceName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_test.xiang_mu_ming_cheng') }}:</span>
          <span class="value">{{ detail.locationName }}</span>
        </el-col>
        <el-col :span="16">
          <span class="label">{{ $t('components_contract_stop_test.shi_yong_di_dian') }}:</span>
          <span class="value">{{ detail.country || '' }}{{ detail.province || '' }}{{ detail.city || '' }}{{ detail.useAddress }}</span>
        </el-col>
      </el-row>
    </div>
    <h1 class="item-title">{{ $t('components_contract_stop_test.sbbgxx') }}</h1>
    <div class="stop-test-tip">
      <i class="icon icon-tishi"></i>
      <span>{{ $t('components_contract_stop_test.rxzzyjzzdsbzdsyhtzzz')}}</span>
    </div>
    <div style="margin-bottom: 30px">
      <custom-table type="checkbox" v-model="selectList" :column="tableColumn" :data="dataList" @filter="filterChange" @sort="sortChange" :slots="['backLocation']">
        <!-- 退回地点 -->
        <template slot="backLocation" slot-scope="scope">
          <custom-select
            width="96%"
            :disabled="model.type === 'watch'"
            v-model="scope.row.deviceBackOrgId"
            url="PartnerHqSc"
            :params="{ orderDeviceId: scope.row.orderDeviceId }"
            :props="{ label: 'partnerName', value: 'partnerOrgId' }"
            @change="onSelectBackOrg($event, scope.row)"
          ></custom-select>
        </template>
      </custom-table>
    </div>
    <el-form :model="form" ref="form" label-width="auto" :rules="rules">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('components_contract_stop_test.shen_qing_miao_shu')" prop="changeDesc">
            <el-input :disabled="model.type === 'watch'" type="textarea" :rows="4" :placeholder="$t('components_contract_stop_test.qtxggsbdyy')" v-model="form.changeDesc" style="width: 636px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '', // 新增时为orderId, 编辑查看时为changeId
        };
      },
    },
  },
  data() {
    return {
      tableCode: 'trialEnd',
      dataList: [],
      selectList: [],
      detail: {},
      form: {
        changeOrderId: '',
        orderId: '',
        changeOrderDevices: [],
        changeDesc: '',
      },
    };
  },
  mounted() {
    this.getTableColumn();
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        changeDesc: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.orderId = this.model.changeId;
        this.getOrderInfo();
        this.getDeviceList();
      }
      if (this.model.type === 'edit') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.getDeviceList(list);
        });
      }
      if (this.model.type === 'watch') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.dataList = list;
          this.dataList.forEach((item) => {
            item.isExists = true;
            this.$refs.customTb1.$emit('toggleRowSelection', item, true);
          });
        });
      }
    },
    // 订单信息
    getOrderInfo: function () {
      this.$getJSON(apis.ChangeOrderInfo, {
        orderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
      });
    },
    // 获取变更详情
    getChangeDetail: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.OrderChangeInfo, {
        changeOrderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
        this.form.orderId = res.data.orderId;
        this.form.changeDesc = res.data.changeDesc;
        cb(res.data.changeDeviceInfos);
      });
    },
    // 合同设备列表
    getDeviceList: function (selectDevice) {
      this.$getJSON(apis.OrderChangeDeviceList, {
        orderId: this.form.orderId,
        showDeviceType: 1,
        contractChangeType: 24,
        bizState: ['21', '22', '29'],
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.deviceBackOrgId = '';
          item.deviceBackOrgName = '';
          item.isExists = !!item.renewalContractNo;
        });
        this.dataList = list;
        if (selectDevice) {
          this.dataList.forEach((item) => {
            const row = selectDevice.find(t => t.orderDeviceId === item.orderDeviceId);
            if (row) {
              item.deviceBackOrgId = row.deviceBackOrgId;
              item.deviceBackOrgName = row.deviceBackOrgName;
            }
          });
        }
      });
    },
    // 选择退回地址
    onSelectBackOrg: function (data, row) {
      row.deviceBackOrgName = data.partnerName;
    },
    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const hasEmpty = this.selectList.find(t => !t.deviceBackOrgId);
        if (hasEmpty) {
          this.$message.error(this.$t('components_contract_stop_test.qxzsysbthdd'));
          return;
        }
        this.form.isStartApprove = approve || 0;
        this.form.changeOrderDevices = this.selectList;
        this.$postJSON(apis.StopTestSave, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
        });
      });
    },
  },
};
</script>

<style lang="scss">
.stop-test-tip {
  background: rgba(254, 244, 219, 1);
  margin-bottom: 16px;
  padding-left: 10px;
  .icon {
    color: #eebf4d;
    font-size: 12px;
    margin-right: 10px;
  }
  span {
    line-height: 32px;
    color: #6c757d;
    font-size: 12px;
  }
}
</style>
